import React from "react";
import { Context,Hooks,Util } from "@xt/xtbase";
const {XtContext} = Context;
const {useTranslation} = Hooks;
const {Big,getUrl,showRate} = Util;
import styles from "./list.module.less";
import { useStore } from '@/models';
import { observer } from 'mobx-react-lite';
import Star from "./star";
import {get_price_supported} from "@/api/v4/market";
import Swal from "@/utils/swal";
import AiSelectNavButton from "@/components/App/AiSelectNavButton";
import { isAiselectEligibleSymbol } from "@/utils/aiSelectEligible";

const MarketListList = ({ marketType, doc, style, onLongPress }) => {
  const t = useTranslation();
  const [appState] = React.useContext(XtContext);
  const {lang, theme} = appState;
  const {fund,market} = useStore();
  const priceDomRef = React.useRef();
  const longPressTimer = React.useRef(null);
  const longPressTriggered = React.useRef(false);
  const LONG_PRESS_DURATION = 500;

  // 行内的可点击元素（⭐ 收藏按钮、链接等）不参与长按，避免短按时误触 Add/Remove 气泡。
  // 注意：本组件根 <div> 自身带有 role="button"，所以不能把 [role='button'] 放进匹配器，否则
  //      e.target.closest("[role='button']") 会匹配到行本身，导致任何位置都取消长按。
  const isInteractiveTarget = (target) => {
    if (!target || typeof target.closest !== "function") return false;
    return !!target.closest("button, a, input");
  };

  const startLongPress = (e) => {
    if (!onLongPress) return;
    if (isInteractiveTarget(e.target)) return;
    longPressTriggered.current = false;
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;
    longPressTimer.current = setTimeout(() => {
      longPressTriggered.current = true;
      onLongPress({ x: clientX, y: clientY, symbol: doc.s });
    }, LONG_PRESS_DURATION);
  };

  const cancelLongPress = () => {
    if (longPressTimer.current) {
      clearTimeout(longPressTimer.current);
      longPressTimer.current = null;
    }
  };
  React.useEffect(()=>{
    const el = priceDomRef.current;
    const subEl = el.querySelector("*");
    const ratio = el.offsetWidth / subEl.offsetWidth;
    if (ratio < 1) {
      subEl.style.display = "inline-block";
      subEl.style.transform = `scale(${ratio})`;
      subEl.style.transformOrigin = "0 50%";
    } else {
      subEl.style.display = null;
      subEl.style.transform = null;
      subEl.style.transformOrigin = null;
    }
  },[]);
  const getColorClsOC = ()=> {
    if (!doc.oc || doc.oc == doc.c) return "";
    return doc.c > doc.oc ? "up-color" : "down-color";
  }
  const getColorCls = ()=> {
    if (!doc.cr && !doc.r) return "";
    return +(doc.cr || doc.r) > 0 ? styles["up-color"] : styles["down-color"];
  }
  const getPrice = ()=>{
    const { marketConfig } = market;

    return Big(doc.c || 0).toFixedCy(marketConfig[doc.s] ? marketConfig[doc.s].buyPoint : 2);
  }
  const getPriceAssist = () => {
    //计算当前币价的折合价格
    const result = fund.getCoinValue(doc.c, doc.s.split("_")[1].toLowerCase());
    return `${Big(result || 0).toFixedCy()} ${fund.assist.name}`;
  }
  const getPriceHigh = () => {
    const { marketConfig } = market;
    return Big(+doc.h || 0).toFixedCy(marketConfig[doc.s] ? marketConfig[doc.s].buyPoint : 2);
  } //最高价
  const getPriceLow = () => {
    const { marketConfig } = market;
    return Big(+doc.l || 0).toFixedCy(marketConfig[doc.s] ? marketConfig[doc.s].buyPoint : 2);
  } //最高价
  const getVol = () => {
    if (!doc.v) return "--";

    //const market = item[0];
    let volume = +doc.v || 0;

    if (lang === "zh-CN") {
      if (volume > 1e8) {
        volume = Big(volume / 1e8).toFixedMaxCy(4) + "亿";
      } else if (volume > 1e4) {
        volume = Big(volume / 1e4).toFixedMaxCy(2) + "万";
      } else {
        volume = Big(volume).toFixedCy();
      }
    } else {
      if (volume > 1e8) {
        volume = Big(volume / 1e6).toFixedMaxCy(4) + "M";
      } else if (volume > 1e4) {
        volume = Big(volume / 1e3).toFixedMaxCy(2) + "K";
      } else {
        volume = Big(volume).toFixedCy();
      }
    }

    return volume;
    //return volume + ' ' + market.split('_')[0].toUpperCase();
  } //成交量
  const handleRowClick = () => {
    if (longPressTriggered.current) {
      longPressTriggered.current = false;
      return;
    }
    if (marketType === "spot") {
      const core = String(doc.s || "").toLowerCase().replace(/_cfd$/i, "");
      const parts = core.split("_").filter(Boolean);
      if (parts.length >= 2) {
        const crypto = (parts[0] || "").toUpperCase();
        const quote = (parts[1] || "").toUpperCase();
        if (crypto && quote) {
          window.location.href = getUrl(
            `/futures/contract/spot?from=${encodeURIComponent(quote)}&to=${encodeURIComponent(crypto)}`
          );
        }
      }
      return;
    }
    if (marketType === "optional") {
      const { marketConfig } = market;
      const isCfd = marketConfig?.[doc.s] && String(marketConfig[doc.s].type).toUpperCase() === "CFD";
      if (isCfd) window.location.href = getUrl("/futures/detail/" + doc.s);
      return;
    }
    window.location.href = getUrl("/futures/detail/" + doc.s);
  };

  const handleContextMenu = (e) => {
    if (!onLongPress) return;
    if (isInteractiveTarget(e.target)) return;
    e.preventDefault();
    longPressTriggered.current = true;
    onLongPress({ x: e.clientX, y: e.clientY, symbol: doc.s });
  };

  const showAiColumn = marketType === "fiat-m" || marketType === "usdt-m" || marketType === "optional";

  return (
    <div
      className={`${styles["trade-market__container__list"]}${
        marketType === "optional" ? " " + styles["trade-market__container__listFavChangeInset"] : ""
      }${showAiColumn ? " " + styles["trade-market__container__listWithAi"] : ""}`}
      style={style}
      onClick={handleRowClick}
      onMouseDown={startLongPress}
      onMouseUp={cancelLongPress}
      onMouseLeave={cancelLongPress}
      onTouchStart={startLongPress}
      onTouchEnd={cancelLongPress}
      onTouchMove={cancelLongPress}
      onTouchCancel={cancelLongPress}
      onContextMenu={handleContextMenu}
      role="button"
    >
      {/* 第一列：Name / Total */}
      <div className={styles.iName}>
        <div className={styles.nameWrapper}>
          <div className={styles.nameRow}>
            {doc.name ? <div>
              <b>{doc.name}</b>
            </div> : <div>
              <b>{fund.getCurrencyDisplayName(doc.s.split('_')[0].toLowerCase())}</b>
              <span> / {fund.getCurrencyDisplayName(doc.s.split('_')[1].toLowerCase())}</span>
            </div>}
            {/* Optional tab 中，type 为 CFD 的币对显示 NEW tag */}
            {marketType === "optional" && (() => {
              const { marketConfig } = market;
              if (!marketConfig || Object.keys(marketConfig).length === 0) {
                return null;
              }
              const theMarket = marketConfig[doc.s];
              if (theMarket && theMarket.type !== undefined && theMarket.type !== null && String(theMarket.type).toUpperCase() === "CFD") {
                return <span className={styles.newTag}>NEW</span>;
              }
              return null;
            })()}
          </div>
          <div className={styles.volumeRow}>
            {marketType !== "spot" && <Star marketType={marketType} symbol={doc.s}/>}
            <span>{getVol()}</span>
          </div>
        </div>
      </div>

      {showAiColumn ? (
        <div className={styles.iAi}>
          {isAiselectEligibleSymbol(doc.s, market.marketConfig) ? (
            <span className={styles.aiSelectWrap} onClick={(e) => e.stopPropagation()}>
              <AiSelectNavButton symbol={doc.s} aria-label={t("header.aicopy")} />
            </span>
          ) : null}
        </div>
      ) : null}

      {/* 第二列：Last Price */}
      <div ref={priceDomRef} className={styles.iPrice}>
        <div className={styles.priceRow}>
          <b className={getColorClsOC()}>{getPrice()}</b>
        </div>
        <div className={styles.priceAssistRow}>
          <small>{getPriceAssist()}</small>
        </div>
      </div>

      {/* 第三列：Change（带背景色） */}
      <div className={styles.iRate}>
        <span className={`${styles.changeBadge} ${getColorCls()}`}>
          {showRate((doc.cr || doc.r) * 100)}
        </span>
      </div>

      {/* 隐藏其他列，按设计稿只显示三列 */}
      {/* <div>
        <span>{getPriceHigh()}</span>
      </div>

      <div>
        <span>{getPriceLow()}</span>
      </div>

      <div>
        <span>{getVol()}</span>
      </div>

      <div>
        <a style={{fontSize:"14px",marginRight:"5px"}} onClick={async (e)=>{
          e.stopPropagation();
          var currency = doc.s.substring(0,doc.s.indexOf('_'));
          var result = await get_price_supported({
            params:{
              currency
            }
          });
          if(result)
          {
            window.location.href = getUrl("/price/"+currency);
          }
          else
            Swal.fadeError(t("market.currenyNotOpen"));
        }}>
          {t('market.Detail')}
        </a>
        <a href={getUrl("/trade/"+doc.s)} style={{color:"var(--primary-color)",fontSize:"14px"}}>
          {t('trade.trading')}
        </a>
      </div> */}
  </div>
  );
}
export default observer(MarketListList);
